<template>
	<v-card>
		<v-simple-table dense class="table">
			<thead class="v-title-center">
				<tr>
					<th></th>
					<th></th>
					<th></th>
					<th>Energía</th>
					<th></th>
					<th>Macronutrimentos</th>
					<th></th>
					<th>Agua</th>
					<th>Calcio</th>
					<th>Fósforo</th>
					<th>Potasio</th>
					<th>Sodio</th>
				</tr>
			</thead>
			<tbody style="text-align: center;">
				<tr>
					<td class="border-row">Grupo</td>
					<td class="border border-row">Tipo</td>
					<td class="border border-row">Cantidad</td>
					<td class="border border-row">KCAL</td>
					<td class="border border-row">Proteína</td>
					<td class="border-row">Lípidos</td>
					<td class="border-row">HC</td>
					<td class="border border-row">ml</td>
					<td class="border border-row">mg</td>
					<td class="border border-row">mg</td>
					<td class="border border-row">mg</td>
					<td class="border border-row">mg</td>
				</tr>
				<template v-for="gru in valor.grupos">
					<tr v-for="(tip, index) in gru.tipos" :key="index">
						<td
							v-if="index === Math.ceil(gru.tipos.length / 2) - 1"
						>
							{{ gru.grupo }}
						</td>
						<td
							v-else
							:class="
								index === gru.tipos.length - 1
									? ' border-row'
									: ''
							"
						></td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.tipo }}
						</td>
						<td
							:class="
								'border v-text' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							<v-text-field
								@change="updateTotales"
								dense
								v-model="tip.cantidad"
								class="text-50"
							></v-text-field>
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.kcal * tip.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.proteina * tip.cantidad }}
						</td>
						<td
							:class="
								index === gru.tipos.length - 1
									? ' border-row'
									: ''
							"
						>
							{{ tip.lipidos * tip.cantidad }}
						</td>
						<td
							:class="
								index === gru.tipos.length - 1
									? ' border-row'
									: ''
							"
						>
							{{ tip.hc * tip.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.ml * tip.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.mgC * tip.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.mgF * tip.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.mgP * tip.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === gru.tipos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ tip.mgS * tip.cantidad }}
						</td>
					</tr>
				</template>
				<template v-for="(sup, index) in valor.suplementos">
					<tr :key="index">
						<td class="border-row">
							{{ sup.nombre }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						></td>
						<td
							:class="
								'border v-text' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							<v-text-field
								@change="updateTotales"
								dense
								v-model="sup.cantidad"
								class="text-50"
							></v-text-field>
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.kcal * sup.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.proteina * sup.cantidad }}
						</td>
						<td
							:class="
								index === valor.suplementos.length - 1
									? ' border-row'
									: ''
							"
						>
							{{ sup.lipidos * sup.cantidad }}
						</td>
						<td
							:class="
								index === valor.suplementos.length - 1
									? ' border-row'
									: ''
							"
						>
							{{ sup.hc * sup.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.ml * sup.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.mgC * sup.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.mgF * sup.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.mgP * sup.cantidad }}
						</td>
						<td
							:class="
								'border' +
									(index === valor.suplementos.length - 1
										? ' border-row'
										: '')
							"
						>
							{{ sup.mgS * sup.cantidad }}
						</td>
					</tr>
				</template>
				<tr>
					<td class="border border-row">Total</td>
					<td class="border-row"></td>
					<td class="border-row"></td>
					<td class="border border-row">{{ totales.kcal }}</td>
					<td class="border border-row">{{ totales.proteina }}</td>
					<td class="border border-row">{{ totales.lipidos }}</td>
					<td class="border border-row">{{ totales.hc }}</td>
					<td class="border border-row">{{ totales.ml }}</td>
					<td class="border border-row">{{ totales.mgC }}</td>
					<td class="border border-row">{{ totales.mgF }}</td>
					<td class="border border-row">{{ totales.mgP }}</td>
					<td class="border border-row">{{ totales.mgS }}</td>
				</tr>
			</tbody>
		</v-simple-table>
		<v-container>
			<v-row>
				<v-col cols="2">
					<v-card-text>% Adecuación</v-card-text>
				</v-col>
				<v-col cols="3">
					<v-text-field
						v-model="valor.adecuacion"
						hide-details="auto"
						solo
						readonly
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-dialog width="500px">
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="primary" v-bind="attrs" v-on="on"
								>Agregar Suplemento</v-btn
							>
						</template>
						<template v-slot:default="dialog">
							<v-card>
								<v-layout column>
									<v-card-text
										label="Suplementos"
									></v-card-text>
									<v-select
										label="Suplemento"
										:items="valor.suplementoItems"
										v-model="valor.suplementoSelected"
									></v-select>
									<v-text-field
										label="Producto"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.nombre"
									></v-text-field>
									<v-text-field
										label="Kcal"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.kcal"
									></v-text-field>
									<v-text-field
										label="Proteína"
										:suffix="g"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.proteina"
									></v-text-field>
									<v-text-field
										label="Lípidos"
										:suffix="g"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.lipidos"
									></v-text-field>
									<v-text-field
										label="HC"
										:suffix="g"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.hc"
									></v-text-field>
									<v-text-field
										label="Agua"
										:suffix="ml"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.ml"
									></v-text-field>
									<v-text-field
										label="Calcio"
										:suffix="mg"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.mgC"
									></v-text-field>
									<v-text-field
										label="Fósforo"
										:suffix="mg"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.mgF"
									></v-text-field>
									<v-text-field
										label="Potasio"
										:suffix="mg"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.mgP"
									></v-text-field>
									<v-text-field
										label="Sodio"
										:suffix="mg"
										v-if="
											valor.suplementoSelected == 'Otro'
										"
										v-model="nuevo.mgS"
									></v-text-field>
								</v-layout>
								<v-layout column>
									<v-btn
										@click="
											dialog.value = false;
											crearNuevo();
										"
										color="primary"
										>Guardar</v-btn
									>
								</v-layout>
							</v-card>
						</template>
					</v-dialog>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
export default {
	props: ["value"],
	name: "calculoEquivalentes",
	data() {
		return {
			valor: {},
			totales: {
				kcal: 0,
				proteina: 0,
				lipidos: 0,
				hc: 0,
				ml: 0,
				mgC: 0,
				mgF: 0,
				mgP: 0,
				mgS: 0
			},
			nuevo: {
				nombre: "",
				cantidad: 1,
				kcal: 0,
				proteina: 0,
				lipidos: 0,
				hc: 0,
				ml: 0,
				mgC: 0,
				mgF: 0,
				mgP: 0,
				mgS: 0
			}
		};
	},
	methods: {
		crearNuevo() {
			if (this.valor.suplementoSelected == "Otro" && this.nuevo.nombre) {
				this.valor.suplementos.push(this.nuevo);
				this.nuevo = {
					nombre: "",
					cantidad: 1,
					kcal: 0,
					proteina: 0,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				};
			} else {
				for (
					let i = 0;
					i < this.valor.suplementoItemsObjects.length;
					++i
				) {
					if (
						this.valor.suplementoItemsObjects[i].nombre ==
						this.valor.suplementoSelected
					) {
						this.valor.suplementos.push(
							this.valor.suplementoItemsObjects[i]
						);
						break;
					}
				}
			}
		},
		updateTotales() {
			let obj = {
				kcal: 0,
				proteina: 0,
				lipidos: 0,
				hc: 0,
				ml: 0,
				mgC: 0,
				mgF: 0,
				mgP: 0,
				mgS: 0
			};

			for (let i = 0; i < this.valor.grupos.length; i++) {
				for (let j = 0; j < this.valor.grupos[i].tipos.length; j++) {
					obj.kcal +=
						this.valor.grupos[i].tipos[j].kcal *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.proteina +=
						this.valor.grupos[i].tipos[j].proteina *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.lipidos +=
						this.valor.grupos[i].tipos[j].lipidos *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.hc +=
						this.valor.grupos[i].tipos[j].hc *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.ml +=
						this.valor.grupos[i].tipos[j].ml *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.mgC +=
						this.valor.grupos[i].tipos[j].mgC *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.mgF +=
						this.valor.grupos[i].tipos[j].mgF *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.mgP +=
						this.valor.grupos[i].tipos[j].mgP *
						this.valor.grupos[i].tipos[j].cantidad;
					obj.mgS +=
						this.valor.grupos[i].tipos[j].mgS *
						this.valor.grupos[i].tipos[j].cantidad;
				}
			}
			for (let i = 0; i < this.valor.suplementos.length; i++) {
				obj.kcal +=
					this.valor.suplementos[i].kcal *
					this.valor.suplementos[i].cantidad;
				obj.proteina +=
					this.valor.suplementos[i].proteina *
					this.valor.suplementos[i].cantidad;
				obj.lipidos +=
					this.valor.suplementos[i].lipidos *
					this.valor.suplementos[i].cantidad;
				obj.hc +=
					this.valor.suplementos[i].hc *
					this.valor.suplementos[i].cantidad;
				obj.ml +=
					this.valor.suplementos[i].ml *
					this.valor.suplementos[i].cantidad;
				obj.mgC +=
					this.valor.suplementos[i].mgC *
					this.valor.suplementos[i].cantidad;
				obj.mgF +=
					this.valor.suplementos[i].mgF *
					this.valor.suplementos[i].cantidad;
				obj.mgP +=
					this.valor.suplementos[i].mgP *
					this.valor.suplementos[i].cantidad;
				obj.mgS +=
					this.valor.suplementos[i].mgS *
					this.valor.suplementos[i].cantidad;
			}
			this.totales = obj;
		}
	},
	mounted() {
		this.valor = this.value || {
			adecuacion: "",
			suplementoItems: [
				"Nepro HP (237 ml)",
				"Nepro LP (237 ml)",
				"Enterex RNL (237 ml)",
				"Fressuport RNL (66 g)",
				"Ensure Regular (237 ml)",
				"RenNut (70 g)",
				"Supportan (200 ml)",
				"Otro"
			],
			suplementoSelected: "",
			suplementoItemsObjects: [
				{
					nombre: "Nepro HP (237 ml)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				},
				{
					nombre: "Nepro LP (237 ml)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				},
				{
					nombre: "Enterex RNL (237 ml)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				},
				{
					nombre: "Fressuport RNL (66 g)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				},
				{
					nombre: "Ensure Regular (237 ml)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				},
				{
					nombre: "RenNut (70 g)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				},
				{
					nombre: "Supportan (200 ml)",
					cantidad: 1,
					kcal: 25,
					proteina: 2,
					lipidos: 0,
					hc: 0,
					ml: 0,
					mgC: 0,
					mgF: 0,
					mgP: 0,
					mgS: 0
				}
			],
			suplementos: [],
			grupos: [
				{
					grupo: "Verduras",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Moderado",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 185,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Frutas",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Moderado",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 185,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				},
				{
					grupo: "Cereal s/g",
					tipos: [
						{
							tipo: "Bajo",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 100,
							mgS: 0
						},
						{
							tipo: "Alto",
							cantidad: 1,
							kcal: 25,
							proteina: 2,
							lipidos: 0,
							hc: 4,
							ml: 150,
							mgC: 0,
							mgF: 0,
							mgP: 340,
							mgS: 0
						}
					]
				}
			]
		};
		this.updateTotales();
	},
	watch: {
		valor: {
			deep: true,
			handler() {
				this.$emit("input", this.valor);
			}
		},
		value() {
			if (this.value) {
				this.valor = this.value;
			}
		}
	}
};
</script>
<style>
.v-title-center {
	color: #1c62ad;
	font-size: 24px;
	font-weight: 400;
	text-align: center;
}
.border {
	border-left: 1px solid gray;
}
.border-row {
	border-bottom: 1px solid black !important;
}
.v-text {
	padding: none;
	margin: none;
}
.text-50 {
	width: 50px;
}
.theme--light.v-data-table
	> .v-data-table__wrapper
	> table
	> tbody
	> tr:not(:last-child)
	> td:not(.v-data-table__mobile-row) {
	border-bottom: none;
}
</style>
